import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import { AuthService } from '../../services/auth';
import { SecurityLayout } from '../../layouts/security';
import { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { NotificationManager } from "react-notifications";
import styles from './SignIn.module.scss';
import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const authService = new AuthService();

export const SignIn = () => {
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleMouseDownPassword = () => setShowPassword(!showPassword);

    const handleLoginSuccess = (response) => {
        sessionStorage.setItem('token', response.data);
        NotificationManager.success('Login realizado com sucesso', "", 3000);
        setLoading(false);
        setTimeout(() => {
            window.location.href = '/';
        }, 500);
    }

    /**
     * Error error Login
     */
    function handleLoginError(err) {
        if (err.status == 404) {
            setLoading(false);
            NotificationManager.error('Usuário não encontrado.', "", 3000);
        } else if (err.status == 400) {
            setLoading(false);
            NotificationManager.error('Senha incorreta.', "", 3000);
        } else {
            setLoading(false);
            NotificationManager.error('Erro ao realizar login, tente novamente.', "", 3000);
        }
    }


    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        const data = new FormData(event.currentTarget);
        authService.login(data.get('user'), data.get('password'))
            .then((response) => {
                if (response.status === 200) {
                    handleLoginSuccess(response);
                } else {
                    setLoading(false);
                }
            })
            .catch((error) => {
                if (error.response) {
                    handleLoginError(error.response);
                } else {
                    setLoading(false);
                    NotificationManager.error('Erro ao realizar login, tente novamente.', "", 3000);
                }
            });
    };

    return (
        <SecurityLayout>
            <CssBaseline />
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                <TextField
                    className={styles.input}
                    margin="normal"
                    required
                    fullWidth
                    id="user"
                    label="Usuário"
                    name="user"
                    autoComplete="user"
                    autoFocus
                />
                <TextField
                    className={styles.input}
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="Senha"
                    type={showPassword ? "text" : "password"}
                    InputProps={{ // <-- This is where the toggle button is added.
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                >
                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                    id="password"
                    autoComplete="current-password"
                />
                {/* <FormControlLabel
                    control={<Checkbox value="remember" color="primary" />}
                    label="Lembre de mim"
                /> */}
                <LoadingButton
                    loading={loading}
                    loadingPosition="start"
                    style={{ backgroundColor: '#212121', color: 'white' }}
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                >
                    Entrar
                </LoadingButton>
            </Box>
        </SecurityLayout>
    );
}